import { render, staticRenderFns } from "./ModalChangeLabel.vue?vue&type=template&id=c2ccc3bc&"
import script from "./ModalChangeLabel.vue?vue&type=script&lang=js&"
export * from "./ModalChangeLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports